var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0367 12.4208C16.6517 12.7967 16.4317 13.3375 16.4867 13.915C16.5692 14.905 17.4767 15.6292 18.4667 15.6292H20.2083V16.72C20.2083 18.6175 18.6592 20.1667 16.7617 20.1667H6.23834C4.34084 20.1667 2.79167 18.6175 2.79167 16.72V10.5509C2.79167 8.65336 4.34084 7.10419 6.23834 7.10419H16.7617C18.6592 7.10419 20.2083 8.65336 20.2083 10.5509V11.8709H18.3567C17.8433 11.8709 17.3758 12.0725 17.0367 12.4208Z",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79167 11.3758V7.1867C2.79167 6.09587 3.46084 5.12416 4.47834 4.73916L11.7567 1.98916C12.8933 1.55833 14.1125 2.40169 14.1125 3.62085V7.10418",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1789 12.806V14.6944C21.1789 15.1985 20.7756 15.611 20.2622 15.6293H18.4656C17.4756 15.6293 16.5681 14.9052 16.4856 13.9152C16.4306 13.3377 16.6506 12.7968 17.0356 12.421C17.3747 12.0727 17.8422 11.871 18.3556 11.871H20.2622C20.7756 11.8894 21.1789 12.3018 21.1789 12.806Z",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91667 11H13.3333",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWallet);
export default __webpack_public_path__ + "static/media/empty-wallet.314fc7c1a2af5016980adf9d5038c23a.svg";
export { ForwardRef as ReactComponent };